import React from 'react';
export function TermsOfService() {
  return <div className="prose prose-lg max-w-none text-gray-700" data-id="element-53">
      <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-54">
        Términos y Condiciones de Servicio
      </h3>
      <p className="mb-4" data-id="element-55">
        <strong data-id="element-56">Última actualización:</strong>{' '}
        {new Date().toLocaleDateString('es-ES')}
      </p>

      <h4 className="text-lg font-semibold text-gray-900 mt-6 mb-3" data-id="element-57">
        1. Aceptación de los Términos
      </h4>
      <p className="mb-4" data-id="element-58">
        Al acceder y utilizar este sitio web y comprar nuestros productos
        digitales, usted acepta estar sujeto a estos Términos y Condiciones de
        Servicio y a todas las leyes y regulaciones aplicables.
      </p>

      <h4 className="text-lg font-semibold text-gray-900 mt-6 mb-3" data-id="element-59">
        2. Descripción del Producto
      </h4>
      <p className="mb-4" data-id="element-60">
        Ofrecemos una guía digital informativa sobre cómo manejar deudas
        antiguas utilizando las leyes federales de protección al consumidor de
        Estados Unidos. Este producto es:
      </p>
      <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-61">
        <li data-id="element-62">Un producto digital de información educativa</li>
        <li data-id="element-63">No constituye asesoramiento legal profesional</li>
        <li data-id="element-64">Entregado instantáneamente tras la compra</li>
        <li data-id="element-65">Para uso personal y no comercial</li>
      </ul>

      <h4 className="text-lg font-semibold text-gray-900 mt-6 mb-3" data-id="element-66">
        3. Compra y Pago
      </h4>
      <p className="mb-4" data-id="element-67">Al realizar una compra, usted garantiza que:</p>
      <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-68">
        <li data-id="element-69">Tiene 18 años o más</li>
        <li data-id="element-70">La información de pago proporcionada es precisa y completa</li>
        <li data-id="element-71">Está autorizado para usar el método de pago seleccionado</li>
        <li data-id="element-72">Acepta pagar el precio indicado más cualquier cargo aplicable</li>
      </ul>

      <h4 className="text-lg font-semibold text-gray-900 mt-6 mb-3" data-id="element-73">
        4. Entrega del Producto
      </h4>
      <p className="mb-4" data-id="element-74">
        El producto digital será entregado inmediatamente después de la
        confirmación del pago a la dirección de correo electrónico proporcionada
        durante la compra.
      </p>

      <h4 className="text-lg font-semibold text-gray-900 mt-6 mb-3" data-id="element-75">
        5. Política de Reembolso
      </h4>
      <p className="mb-4" data-id="element-76">
        Debido a la naturaleza digital de nuestro producto y la entrega
        instantánea, todas las ventas son finales. No ofrecemos reembolsos una
        vez que el producto ha sido entregado y el acceso ha sido proporcionado.
      </p>

      <h4 className="text-lg font-semibold text-gray-900 mt-6 mb-3" data-id="element-77">
        6. Propiedad Intelectual
      </h4>
      <p className="mb-4" data-id="element-78">
        Todo el contenido incluido en este producto digital, incluyendo textos,
        gráficos, logos, y materiales, está protegido por derechos de autor y
        otras leyes de propiedad intelectual. Usted no puede:
      </p>
      <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-79">
        <li data-id="element-80">Reproducir, distribuir o vender el contenido</li>
        <li data-id="element-81">Modificar o crear trabajos derivados</li>
        <li data-id="element-82">Usar el contenido con fines comerciales</li>
        <li data-id="element-83">Compartir su acceso con terceros</li>
      </ul>

      <h4 className="text-lg font-semibold text-gray-900 mt-6 mb-3" data-id="element-84">
        7. Descargo de Responsabilidad
      </h4>
      <p className="mb-4" data-id="element-85">
        Este producto es solo para fines informativos y educativos. No
        constituye asesoramiento legal, financiero o profesional. Usted debe
        consultar con un profesional calificado antes de tomar cualquier acción
        basada en la información proporcionada.
      </p>
      <p className="mb-4" data-id="element-86">
        No garantizamos resultados específicos. Los resultados pueden variar
        según las circunstancias individuales.
      </p>

      <h4 className="text-lg font-semibold text-gray-900 mt-6 mb-3" data-id="element-87">
        8. Limitación de Responsabilidad
      </h4>
      <p className="mb-4" data-id="element-88">
        En ningún caso seremos responsables por daños directos, indirectos,
        incidentales, especiales o consecuentes que resulten del uso o la
        imposibilidad de usar nuestro producto.
      </p>

      <h4 className="text-lg font-semibold text-gray-900 mt-6 mb-3" data-id="element-89">
        9. Modificaciones
      </h4>
      <p className="mb-4" data-id="element-90">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios entrarán en vigor inmediatamente después de su
        publicación.
      </p>

      <h4 className="text-lg font-semibold text-gray-900 mt-6 mb-3" data-id="element-91">
        10. Ley Aplicable
      </h4>
      <p className="mb-4" data-id="element-92">
        Estos términos se regirán e interpretarán de acuerdo con las leyes de
        Estados Unidos, sin tener en cuenta sus disposiciones sobre conflictos
        de leyes.
      </p>

      <h4 className="text-lg font-semibold text-gray-900 mt-6 mb-3" data-id="element-93">
        11. Contacto
      </h4>
      <p className="mb-4" data-id="element-94">
        Si tiene preguntas sobre estos Términos y Condiciones, puede
        contactarnos a través de los canales proporcionados en nuestro sitio
        web.
      </p>
    </div>;
}